import { render, staticRenderFns } from "./roster.vue?vue&type=template&id=2b1ca017&scoped=true&"
import script from "./roster.vue?vue&type=script&lang=ts&"
export * from "./roster.vue?vue&type=script&lang=ts&"
import style0 from "./roster.vue?vue&type=style&index=0&id=2b1ca017&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1ca017",
  null
  
)

export default component.exports